<template>
  <my-work-skeleton v-if="myWorkLoading"></my-work-skeleton>
  <v-content id="myWorkContent" v-else>
    <v-container class="color1 pageHeader">
      <v-row>
        <v-col cols="12">
          <div class="text-center align-end justify-end">
            <h1 class="display-1">{{ $t("myWork") }}</h1>
          </div>
        </v-col>
      </v-row>
    </v-container>
    <v-container>
      <v-row>
        <v-col cols="12" class="headings">
          <div class="text-left">
            <h3>{{ $t("selectWork") }}</h3>
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-container>
          <v-tabs fixed-tabs background-color="color3" dark v-model="activeTab">
            <v-tab
              v-for="(work, idx) in getMyWork"
              :key="idx"
              @click="workTabClick(work.id)"
            >{{ tl(work.topic) }}</v-tab>
            <v-tab-item v-for="(work, idx) in getMyWork" :key="idx">
              <v-card flat tile>
                <v-img max-height="250" :src="work.image" transition="scale-transition"></v-img>
                <div v-if="work.description">
                  <br>
                  <h3>{{ tl(work.description) }}</h3>
                </div>
                <v-container style="padding-top: 0;">
                  <v-row>
                    <v-col cols="12" style="padding-top: 0;">
                      <v-row v-if="!work.works">
                        <v-col cols="12">
                          <div class="text-center">
                            <p>
                              <i>{{ $t("comingSoon") }}</i>
                            </p>
                          </div>
                        </v-col>
                      </v-row>
                      <v-row v-else v-for="(eachWork, idx) in work.works" :key="idx">
                        <v-card outlined tile class="eachWork" min-width="100%">
                          <v-container class="eachWork">
                            <v-row>
                              <h3>{{ eachWork.title }}</h3>
                            </v-row>
                            <v-row v-if="eachWork.subtitle !== ''">
                              <h4>{{ eachWork.subtitle }}</h4>
                            </v-row>
                            <v-row v-if="eachWork.displayAuthor">
                              <p mb-0><strong><i>{{ eachWork.author }}</i></strong></p>
                            </v-row>
                            <v-row v-if="eachWork.submittedTo">
                              <p mb-0><b>{{ $t("submittedTo") }}: </b><span v-html="eachWork.submittedTo"></span></p>
                            </v-row>
                            <v-row v-if="eachWork.submittedBy">
                              <p mb-0><b>{{ $t("submittedBy") }}: </b><span v-html="eachWork.submittedBy"></span></p>
                            </v-row>
                            <v-row v-if="eachWork.date">
                              <p mb-0>{{ eachWork.date }}</p>
                            </v-row>
                            <v-row v-if="eachWork.description">
                              <p  mb-0 v-html="eachWork.description"></p>
                            </v-row>
                            <v-row v-if="eachWork.publisher">
                              <p mb-0><b>{{ $t("publisher") }}: </b><span v-html="eachWork.publisher"></span></p>
                            </v-row>
                            <v-row v-if="eachWork.myContribution">
                              <p mb-0><b>{{ $t("myContribution") }}: </b><span>{{ eachWork.myContribution }}</span></p>
                            </v-row>
                            <v-row>
                              <v-btn color="success" tile @click="readMoreClick(eachWork, work.topic.en)">
                                <span>{{ $t("readMore") }}</span>
                              </v-btn>
                            </v-row>
                          </v-container>
                        </v-card>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card>
            </v-tab-item>
          </v-tabs>
        </v-container>
      </v-row>
    </v-container>
  </v-content>
</template>

<script>
import MyWorkSkeleton from "@/components/myWork/MyWorkSkeleton";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "MyWork",
  components: {
    myWorkSkeleton: MyWorkSkeleton
  },
  data() {
    return {
      tabMap: {
        thesis: 0, reports: 1, publications: 2, articles: 3, supervision: 4
      },
      revTabMap: {
        0: "thesis", 1: "reports", 2: "publications", 3: "articles", 4: "supervision"
      },
      selectedFolder: null,
      activeTab: null
    };
  },
  computed: {
    ...mapGetters(["myWorkLoading", "getMyWork"]),

  },
  methods: {
    ...mapActions(["fetchMyWorkFromDatabase"]),
    readMoreClick(eachWork, topic) {
      this.$router.push({
        name: "workTopic",
        params: {
          id: eachWork.id
        }
      });
      this.logEvent("button_click", {
        name: "workReadMore",
        topic: topic,
        workId: eachWork.id
      })
    },
    workTabClick(id) {
      this.logEvent("button_click", {
        name: "workTab",
        topic: id
      });
      if (this.$route.params.type !== id) {
        this.$router.push({ params: { type: this.revTabMap[this.tabMap[id]] }});
      }
    }
  },
  watch: {
    '$route.params.type': function(val) {
      this.activeTab = this.tabMap[val];
    }
  },
  beforeMount() {
    this.fetchMyWorkFromDatabase();
    const type = this.$route.params.type;
    if (type in this.tabMap) {
      this.activeTab = this.tabMap[type];
    } else {
      this.$router.push({ params: { type: "thesis" }});
      this.activeTab = 0;
    }
  },
  mounted() {
    this.logEvent("page_load", { 
      pageName: "myWork",
      lang: this.$i18n.locale
     });
  },
  metaInfo() {
    return {
      title: "Dr. Rashmee Rajkarnikar - My Work",
      meta: [
        {
          name: "description",
          content: "Brief overview of work and career of Dr. Rashmee Rajkarnikar. This page includes possibility of navigating to her theses, publications, research articles and supervised works."
        },
        {
          property: "og:title",
          content: "Work of Dr. Rashmee Rajkarnikar"
        },
        {
          property: "og:site_name",
          content: "Dr. Rashmee Rajkarnikar - My Work"
        },
        {
          property: "og:description",
          content: "My works including my Ph.D. Dissertation, theses, various publications, research articles and supervised theses are available for download."
        },
        {
          property: "og:type",
          content: "website"
        },
        {
          property: "og:url",
          content: "https://dr-rashmee.com/en/myWork/thesis"
        },
        {
          property: "og:image",
          content: "https://firebasestorage.googleapis.com/v0/b/newecohelp.appspot.com/o/myWork%2FThesisDissertations.jpg?alt=media&token=806bbe43-06da-441a-af67-994f3e631230"
        }
      ]
    }
  }
};
</script>

<style scoped>
#myWorkContent {
  padding: 0 !important;
}
.headings {
  padding-top: 0;
}
.rootFolderTitle {
  background-color: rgba(0, 0, 0, 0.5);
}
.eachWork {
  padding-left: 5%;
  padding-right: 5%;
  margin-top: 5px;
}
p {
  margin-top: 5px;
  margin-bottom: 0;
}
</style>